module.exports = __webpack_public_path__ + "img/story039.1ae9b5e7.webp";